import * as moment from "moment";

export class TokenDto {
    token: string = '';
    tokenAtualizacao: string = '';
    expiraEm: Date = moment(new Date()).add(7, 'days').toDate();
    tempoAuxiliar: number = 0;

    constructor(init?: Partial<TokenDto>) {
        Object.assign(this, init);
    }
}